import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Location } from "@angular/common";
import { AppSessionService } from "src/app/shared/services/app-session/app-session.service";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PageNotFoundComponent {
  constructor(
    private translate: TranslateService,
    private router: Router,
    private location: Location,
    private appSession: AppSessionService
  ) {}

  returnHome() {
    if (this.appSession.basePath) {
      this.router.navigate([this.appSession.basePath]);
    } else {
      this.router.navigateByUrl("/welcome");
    }
  }

  previvousPage() {
    this.location.back();
  }
}
